export default {
  finalize() {
    setTimeout(function () {
      document.querySelector('#white-paper-wrap')
              .classList.add('white-paper-wrap--loaded');
    }, 300);
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/single-white-paper.js